<template>
  <div id="app">
    <div id="sidebardiv">
      <b-sidebar id="sidebar" title="Menu" shadow>
        <div class="px-3 py-2">
          <b-img :src="require('./assets/Header.jpg')"></b-img>
          <p />
          <nav class="mb-3">
            <b-nav vertical pills small>
              <b-nav-item href="/" @click="hide">Home</b-nav-item>
              <b-nav-item href="/beaver" @click="hide">Rowdy Beaver</b-nav-item>
              <b-nav-item href="/fox" @click="hide">Rowdy Fox</b-nav-item>
              <b-nav-item href="/bear" @click="hide">Rowdy Bear</b-nav-item>
              <b-nav-item href="/coyote" @click="hide">Rowdy Coyote</b-nav-item>
              <hr>
              <h3>Cousin Cabins</h3>
              <b-nav-item href="/borrowedtime" @click="hide">Borrowed Time</b-nav-item>
              <b-nav-item href="/horsefeathers" @click="hide">Horse Feathers</b-nav-item>
              <b-nav-item href="/horsenest" @click="hide">Horse Nest</b-nav-item>
              <hr>
              <b-nav-item href="/contactus" @click="hide">Contact Us</b-nav-item>
            </b-nav>
          </nav>
        </div>
      </b-sidebar>
      <div id="content">
        <div class="sticky-top">
          <div id="topnav">
            <nav class="navbar navbar-default">
              <div class="container-fluid">
                <ul class="nav navbar-nav navbar-left">
                  <img v-b-toggle.sidebar src="./assets/menu.png" />Menu
                </ul>
                <ul class="nav navbar-nav navbar-center">
                  <h1>Beavers Bend Rentals</h1>
                </ul>
                <ul class="nav navbar-nav navbar-right">
                  <li><a href="/contactus">Contact Us</a></li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
        <div class="container-fluid">
          <router-view />
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Vue from 'vue';
import Footer from './components/shared/Footer';

Vue.component('app-footer', Footer);
export default {
  name: 'App',
  components: { Footer },
  methods: {hide() {return true;}}
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#content {
  width: 100%;
  position: relative;
  margin-right: 0;
}
b-nav-item {
  align-items: left;
}
b-row {
  align-content: left;
  margin-top: 1;
  margin-left: 20%;
}
#topnav img {
   width: 20px;
  height: 20px;
}
.b-sidebar-body img {
  margin-left: 10px;
  width: 200px;
  height: 200px;
}

#topnav {
  background: white;
  border-bottom: 1px solid #455a64;
  color: black;
  font-size: 12px;
  width: 100%;
}
@import url('~@/assets/fonts/Pinewood.tff');
h1 {
  font-family: 'Pinewood', pinewood;
  color: darkgreen;
  font-weight: 300;
}
</style>



// WEBPACK FOOTER //
// src/App.vue